import { JSX } from "react";

import { IManualIdentityPreview } from "@/@types/divergence";
import { applyCpfMaskIfNeeded } from "@/utils/cpf-mask";

import { MANUAL_IDENTITY_LABELS } from "../../utils/messages";
import { EMPLOYEE_REGISTRY_PANEL_TEST_ID } from "../../utils/decision-test-ids";

const FieldRow = ({
  label,
  value,
}: {
  label: string;
  value: string | null;
}): JSX.Element => (
  <div className="flex justify-between gap-4 text-sm">
    <span className="text-muted-foreground">{label}</span>
    <span className="font-medium text-right">
      {value?.trim() ? value : MANUAL_IDENTITY_LABELS.EMPTY_FIELD}
    </span>
  </div>
);

export function EmployeeRegistryPanel({
  preview,
}: {
  preview: IManualIdentityPreview;
}): JSX.Element {
  return (
    <div
      data-testid={EMPLOYEE_REGISTRY_PANEL_TEST_ID}
      className="flex flex-col gap-3 rounded-md border p-3"
    >
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.CPF}
        value={applyCpfMaskIfNeeded(preview.identity.cpf)}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.NAME}
        value={preview.identity.name}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.POSITION}
        value={preview.registry.position}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.REGISTRATION}
        value={preview.registry.registration}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.COST_CENTER}
        value={preview.registry.costCenter}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.COMPANY}
        value={preview.registry.companyName}
      />
      <FieldRow
        label={MANUAL_IDENTITY_LABELS.FIELD.SITUATION}
        value={preview.registry.situation}
      />
    </div>
  );
}
